var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { REACT_APP__URL_DATAFAN_BASE } from "@smp/utils";
import { apiRequestDatafan } from "../_helpers";
export const ApiDatafanAccountCredential = {
    Meta: {
        get: (_a) => {
            var { accountCredentialId, extraParams } = _a, query = __rest(_a, ["accountCredentialId", "extraParams"]);
            return apiRequestDatafan({
                endpoint: `${REACT_APP__URL_DATAFAN_BASE}/api/0/account-credentials/meta/${accountCredentialId}/`,
                method: "GET",
                query: Object.assign(Object.assign({}, query), { params: extraParams ? JSON.stringify(extraParams) : undefined }),
            });
        },
    },
    Ok: {
        Groups: {
            list: (projectId, accountId) => apiRequestDatafan({
                endpoint: `${REACT_APP__URL_DATAFAN_BASE}/api/0/account-credentials/meta/${accountId}/?object=ok.groups&project_id=${projectId}`,
                method: "GET",
            }),
        },
    },
    VkGroup: {
        get: (vkGroupId) => apiRequestDatafan({
            endpoint: `${REACT_APP__URL_DATAFAN_BASE}/api/0/account-credentials/vk-group-token/${vkGroupId}/`,
            method: "GET",
        }).then((resp) => {
            if (resp instanceof Response) {
                return undefined;
            }
            return resp;
        }),
    },
    connect: (payload, query) => apiRequestDatafan({
        body: payload,
        endpoint: `${REACT_APP__URL_DATAFAN_BASE}/api/0/account-credentials/connect/`,
        method: "POST",
        query,
    }),
    delete: (_a) => {
        var { credentialId } = _a, query = __rest(_a, ["credentialId"]);
        return apiRequestDatafan({
            endpoint: `${REACT_APP__URL_DATAFAN_BASE}/api/0/account-credentials/${credentialId}/`,
            method: "DELETE",
            query,
        });
    },
    exists: (socialAuthData) => apiRequestDatafan({
        body: socialAuthData,
        endpoint: `${REACT_APP__URL_DATAFAN_BASE}/api/0/account-credential/exists/`,
        method: "POST",
    }),
    info: (credentialId) => apiRequestDatafan({
        endpoint: `${REACT_APP__URL_DATAFAN_BASE}/api/0/account-credentials/info/${credentialId}/`,
        method: "GET",
    }),
    list: (query) => apiRequestDatafan({
        endpoint: `${REACT_APP__URL_DATAFAN_BASE}/api/0/account-credentials/`,
        method: "GET",
        query,
    }),
};
//# sourceMappingURL=account_credential.js.map